import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileUserCashMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "profile-user-cash-message" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25.9c-5.877,1.017-7.2,6.971-9.749,13.348h3v3a3,3,0,0,0,3,3H21v3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.125,5.251H7.5A1.342,1.342,0,0,0,7,7.839l2.655.825a1.342,1.342,0,0,1-.5,2.587H6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 5.251,
			x2: 8.25,
			y2: 3.751
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 12.751,
			x2: 8.25,
			y2: 11.251
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.251,15.75h-1.5v4.5l-4.5-4.5h-3a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5h12a1.5,1.5,0,0,1,1.5,1.5"
		})
	]
});
export default SvgProfileUserCashMessage;
